<div class="activity_card">
  <mat-card>
    <mat-card-content class="mt-0 pt-0">
      <div *ngIf="isCardHasTitle">
        <div class="activity_card__title">{{'shared.components.activity.activity' | translate}}</div>
        <mat-divider class="my-3"></mat-divider>
      </div>
      <div class="activity_card__content">
        <section>
          <ul class="timeline mt-0">
            <li class="timeline__list-item" *ngFor="let item of activityData; let i = index; last as isLast">
              <app-row align="center">
                <app-col cols="auto">
                  <div class="flex align-center"
                    *ngIf="item.action === invoiceActivityStatus.created || item.action === invoiceActivityStatus.approved ||
                  item.action === invoiceActivityStatus.updated || (item.action === invoiceActivityStatus.paid && !isCardHasTitle)">
                    <div class="timeline__list-item-title">
                      <div class="timeline__avatar inline-block">
                        <img src="../../../../assets/images/Ellipse.svg" />
                        <span>{{item.createdBy
                          ? (item.createdBy.firstName?.[0] ?? '').toUpperCase() + (item.createdBy.lastName?.[0] ?? '').toUpperCase()
                          : 'MD'}}</span>
                      </div>
                    </div>
                    <div class="ml-2 flex column">
                      <span class="weight-medium text-900 small">
                        {{item.createdBy ? ((item.createdBy.firstName ?? '') + ' ' + (item.createdBy.lastName ?? '')) : ('shared.components.activity.system' | translate)}}
                        <span class="text-400 small">
                          {{'shared.Enum.InvoiceAction.' + item.action | translate}} {{'shared.components.activity.theInvoice' | translate}}
                        </span>
                      </span>
                      <span class="text-400 small">{{item.createdAt | date}} | {{item.createdAt | date:'shortTime'
                        }}</span>
                    </div>
                  </div>

                  <div class="flex align-center" *ngIf="item.action === invoiceActivityStatus.paid && isCardHasTitle">
                    <div class="timeline__list-item-title">
                      <div class="timeline__avatar inline-block">
                        <span class="bg-success-lighter text-success p-2 radius-1 d-inline-block">
                          <app-icon class="icon  align-middle" size="xs"
                            name="tick-square"></app-icon>
                        </span>
                      </div>
                    </div>
                    <div class="ml-2 flex column">
                      <span class="weight-medium text-900 small">
                        {{item.createdBy ? ((item.createdBy.firstName ?? '') + ' ' + (item.createdBy.lastName ?? '')) : ('shared.components.activity.system' | translate)}}
                        <span class="text-400 small">{{'shared.components.activity.successfully' | translate}}</span>
                      </span>
                      <span class="text-400 small">{{item.createdAt | date}} | {{item.createdAt | date:'shortTime'
                        }}</span>
                    </div>
                  </div>

                  <div class="flex align-center" *ngIf="item.action === invoiceActivityStatus.rejected">
                    <div class="timeline__list-item-title">
                      <div class="timeline__avatar inline-block">
                        <span class="bg-warn-lighter text-warn p-2 radius-1">
                          <app-icon class="icon  align-middle" size="xs"
                            name="close-square"></app-icon>
                        </span>
                      </div>
                    </div>
                    <div class="ml-2 flex column">
                      <span class="weight-medium text-900 small">
                        {{item.createdBy ? ((item.createdBy.firstName ?? '') + ' ' + (item.createdBy.lastName ?? '')) : ('shared.components.activity.system' | translate)}}
                        <span class="text-400 small">
                          {{'shared.Enum.InvoiceAction.' + item.action | translate}}
                          {{'shared.components.activity.TheInvoice' | translate}}
                        </span>
                      </span>
                      <span class="text-400 small">{{item.createdAt | date}} | {{item.createdAt | date:'shortTime'
                        }}</span>
                    </div>
                  </div>

                  <div
                    class="flex align-center"
                    *ngIf="item.action === invoiceActivityStatus.OverDue"
                  >
                    <div class="timeline__list-item-title">
                      <div class="timeline__avatar inline-block">
                        <img src="../../../../assets/images/Ellipse.svg" />
                        <span>MD</span>
                      </div>
                    </div>
                    <div class="ml-2 flex column">
                      <span class="weight-medium text-900 small">
                        Madar
                        <span class="text-400 small">
                          {{'shared.components.activity.Converted' | translate}}
                        </span>
                      </span>
                      <span class="text-400 small">{{item.createdAt | date}} | {{item.createdAt | date:'shortTime' }}</span>
                    </div>
                  </div>
                </app-col>
              </app-row>
              <div class="timeline__list-item-separator" *ngIf="!isLast"></div>
            </li>
          </ul>
        </section>
      </div>
    </mat-card-content>
  </mat-card>
</div>
